import { render, staticRenderFns } from "./SampleConfiguration.vue?vue&type=template&id=3139c454&"
import script from "./SampleConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SampleConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports